import { isTruthyFlag } from "../pages/Manage/Admin/adminUtils";

export function typesEqual(a, b) {
  return (
    String(a || "")
      .trim()
      .toLowerCase() ===
    String(b || "")
      .trim()
      .toLowerCase()
  );
}

/** First active item of an exact content type. Inactive duplicates never win. */
export function pickContentByType(content, type) {
  if (!content || typeof content !== "object") return null;
  const items = Object.values(content).filter((item) =>
    typesEqual(item?.type, type),
  );
  return items.find((item) => isTruthyFlag(item?.active)) || null;
}
